// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useModuleParty } from '../../contexts/ModuleContext';
import useInstructedCollateral from '../queries/collateral/collateral/useInstructedCollateral';

export const useInboundInstructedCollateralCount = () => {
  const { data } = useInstructedCollateral();
  const party = useModuleParty();
  const hasNotifications = data?.flatMap((d) =>
    d.payload.instructedPositions.filter((i) => i.pledgor === party),
  ).length;
  return hasNotifications;
};
